module.exports = __webpack_public_path__ + "img/selected2-min.a4779a0f.png";